import React from 'react';

import { GarageListTable } from '../../styled';
import { isGarageCnd } from './utils';
import getColumns from './GarageTableColumns';

const GarageTable = ({ garages, collectionDeliveryOption, state, setState, onGarageRowClick }) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <GarageListTable
      rowClassName={(garage) => (garage.garageId === state.garageId ? 'selected' : '')}
      onRow={(garage) => ({
        onClick: () => onGarageRowClick(garage),
      })}
      rowKey={(garage) => garage.garageId}
      pagination={{ pageSize: 10 + state.count, position: 'none' }}
      dataSource={garages}
      columns={getColumns(isGarageCnd(collectionDeliveryOption))}
    />
  </div>
);

export default GarageTable;
